import { useEffect, useState } from 'react';
// apis
import { getPoinstofsale } from 'api';
// utils && hooks
import { COUNTRY } from 'utils/country';
import { EDrugManufacturerTypeId } from 'utils/enums/drugmanufacturerTypeId/DrugManufacturerTypeId';
import { useDebounce, useUser } from 'utils/hooks';

const usePosList = () => {
    const { user, userLocaleCountryCode } = useUser({});
    const [searchValue, setSearchValue] = useState<string>('');
    const [data, setData] = useState<any>([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isFirstFetch, setIsFirstFetch] = useState<boolean>(true);
    const [totalRows, setTotalRows] = useState<number>(20);
    const [perPage, setPerPage] = useState<number>(20);
    const searchValueDebounced = useDebounce(searchValue, 500);

    const handleClearSearch = () => {
        setSearchValue('');
        handleGetPointOfSale(20, 1);
    };

    const handleGetPointOfSale = async (rows: number = 20, page: number = 1, search?: string) => {
        setIsLoading(true);
        let res;

        if (!!search) {
            res = await getPoinstofsale(rows, page, search);
        } else {
            res = await getPoinstofsale(rows, page);
        }

        if (res?.data?.meta?.pagination?.total_pages) {
            const { current_page, count, per_page, total, total_pages } = res.data.meta.pagination;
            setCurrentPage(current_page);
            setTotalRows(count);
            setTotalPages(total_pages);
            setPerPage(per_page);
        }

        let mergeDataWithUserPos = res.data.data.map((item) => {
            const pos = user?.pointsOfSale.find((pos) => {
                return item.id === pos.id;
            });
            return { ...item, ...pos };
        });

        // CdO only exist in Argentina
        if (userLocaleCountryCode === COUNTRY.AR) {
            mergeDataWithUserPos?.forEach((POS) => {
                // Verify status CdO
                if (POS?.cdo_status_id !== 3) {
                    // Save original length to compare after filter drugManufacturers
                    const originalLength = POS?.drugManufacturers?.length;

                    // Filter CdO on drugManufacturers object
                    POS.drugManufacturers = POS?.drugManufacturers?.filter(
                        (drugmanufacturer) =>
                            drugmanufacturer.id !== 43 && drugmanufacturer.type_id !== EDrugManufacturerTypeId.vendor,
                    );

                    // Compare original length with new length
                    if (originalLength !== POS.drugManufacturers.length) {
                        // Subtract 1 to availableDrugManufacturers if it was filtered
                        if (POS.availableDrugManufacturers > 0) {
                            POS.availableDrugManufacturers -= 1;
                        }
                        // Then if availableDrugManufacturers change to 0, have to be set on false to render "Configurar droguerías" button
                        if (POS.availableDrugManufacturers === 0) {
                            POS.hasAvailableDrugManufacturers = false;
                        }
                    }
                }
            });
        }

        setData(mergeDataWithUserPos);
        if (isFirstFetch) setIsFirstFetch(false);
        setIsLoading(false);
    };

    useEffect(() => {
        // handleGetPointOfSale();
    }, []);

    useEffect(() => {
        if (!isLoading) {
            handleGetPointOfSale(20, 1, searchValueDebounced);
        }
    }, [searchValueDebounced]);

    return {
        handleClearSearch,
        handleGetPointOfSale,
        searchValue,
        setSearchValue,
        data,
        perPage,
        isLoading,
        isFirstFetch,
        totalRows,
        currentPage,
        totalPages,
    };
};

export default usePosList;
